import React from 'react';
import { Modal } from 'antd';

interface PayoutModalsProps {
  visible: {
    query: boolean;
    json: boolean;
    type: boolean;
  };
  onClose: (modalName: 'query' | 'json' | 'type') => void;
  currentConfig: any;
  queryValue: string;
  t: any;
}

const PayoutModals: React.FC<PayoutModalsProps> = ({
  visible,
  onClose,
  currentConfig,
  queryValue,
  t,
}) => (
  <>
    {/* Query Modal */}
    <Modal
      title={t('simplePayoutBuilder.payoutQuery')}
      open={visible.query}
      onCancel={() => onClose('query')}
      footer={null}
      width={1000}
      maskClosable={false}
    >
      <div className="p-md bg-neutral-30 rounded">
        <pre className="mt-sm whitespace-pre-wrap">{queryValue}</pre>
      </div>
    </Modal>

    {/* JSON Logic Modal */}
    <Modal
      title={t('simplePayoutBuilder.jsonLogic')}
      open={visible.json}
      onCancel={() => onClose('json')}
      footer={null}
      width={1000}
      maskClosable={false}
    >
      <div className="p-md bg-neutral-30 rounded">
        <pre className="mt-sm whitespace-pre-wrap">
          {currentConfig.jsonLogic
            ? JSON.stringify(currentConfig.jsonLogic, null, 2)
            : 'No JSON logic generated yet'}
        </pre>
      </div>
    </Modal>

    {/* Instructions Modal */}
    <Modal
      title={t('simplePayoutBuilder.payOutType')}
      open={visible.type}
      onCancel={() => onClose('type')}
      footer={[]}
      width={1000}
      maskClosable={false}
    >
      <div className="p-md bg-neutral-30 rounded">
        <ul className="mt-sm space-y-3 list-disc pl-md">
          <li className="text-base">
            <strong>{t('simplePayoutBuilder.percentage')}</strong>:{' '}
            {t('simplePayoutBuilder.percentageText')}
          </li>
          <li className="text-base">
            <strong>{t('simplePayoutBuilder.percentageMax&Min')}</strong>:{' '}
            {t('simplePayoutBuilder.percentagedesc')}
          </li>
          <li className="text-base">
            <strong>{t('simplePayoutBuilder.percentageMax')}</strong>:{' '}
            {t('simplePayoutBuilder.percentageMaxdesc')}
          </li>
          <li className="text-base">
            <strong>{t('simplePayoutBuilder.flatPayout')}</strong>:{' '}
            {t('simplePayoutBuilder.flatPayoutTitle')}
          </li>
          <li className="text-base">
            <strong>{t('simplePayoutBuilder.flatPayoutMin&Max')}</strong>:{' '}
            {t('simplePayoutBuilder.flatPayoutdesc')}
          </li>
          <li className="text-base">
            <strong>{t('simplePayoutBuilder.flatPayoutMax')}</strong>:{' '}
            {t('simplePayoutBuilder.flatPayoutMaxdesc')}
          </li>
          <li className="text-base">
            <strong>{t('simplePayoutBuilder.percentageOrFlatType')}</strong>:{' '}
            {t('simplePayoutBuilder.percentageOrFlatTypedesc')}
          </li>
        </ul>
      </div>
    </Modal>
  </>
);

export default PayoutModals;
